module.exports = __webpack_public_path__ + "img/pay.a6df99d9.svg";